











































































import { Component, Prop, Vue, namespace } from 'nuxt-property-decorator'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { mdiHeart, mdiHeartOutline } from '@mdi/js'
import {
  IProductDayItem,
  IProductToCart,
  IProductToFavourites,
} from '~/assets/interfaces/products'
import { ICartItem } from '~/assets/interfaces/cart'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { CART_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import ComponentImage from '~/components/images/image.vue'
import ComponentProductDetailPricesLight from '~/components/products/product-detail-prices-light.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
const cartStore = namespace('cart')
const favouritesStore = namespace('favourites')

@Component({
  components: {
    ComponentImage,
    ComponentProductDetailPricesLight,
    VueCountdown,
    ComponentFormButton,
    ComponentFormButtonIcon,
  },
})
export default class ComponentProductDay extends Vue {
  @Prop({ type: String, default: 'Товар дня' }) readonly titleBlock!: string
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IProductDayItem

  @cartStore.Action('toCart') private toCart!: (
    product: IProductToCart
  ) => Promise<void>

  @cartStore.State('items') private items!: ICartItem[]

  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]

  private icons = {
    mdiHeart,
    mdiHeartOutline,
  }

  private get buyButtonTitle() {
    return this.isInCart ? 'В корзине' : 'В корзину'
  }

  // Пропорция площадки под картинку приходит из данных (например «307 / 224»).
  private get isInFavourites() {
    return !!this.favouritesItems.find((item) => item.id === this.item.id)
  }

  private isLoadingFavourites = false

  private async addToFavourites() {
    this.isLoadingFavourites = true
    await this.toFavourites({ id: this.item.id })
    this.isLoadingFavourites = false
  }

  private isMounted = false
  private mounted(): void {
    this.isMounted = true
    this.$emit('loaded')
  }

  private get isInCart() {
    return !!this.items.find((item) => {
      return item.id === this.item.id
    })
  }

  private get time() {
    if (!this.item.endTime) {
      return 0
    }

    const endTime = Date.parse(this.item.endTime)

    if (!Number.isFinite(endTime)) {
      return 0
    }

    return Math.max(0, endTime - Date.now())
  }

  private isLoading = false

  private async buy() {
    const tempProd = {
      id: this.item.id,
      quantity: 1,
    }

    if (!this.isLoading) {
      this.isLoading = true
      if (this.isInCart) {
        await this.$router.push(filterUrl(CART_PATH))
      } else {
        await this.toCart(tempProd)
      }
    }
    this.isLoading = false
  }

  private transformCountDown(
    props: Record<string, number>
  ): Record<string, string> {
    const newProps: Record<string, string> = {}

    Object.entries(props).forEach(([key, value]) => {
      // Adds leading zero
      const digits = value < 10 ? `0${value}` : value

      newProps[key] = `${digits}`
    })

    return newProps
  }
}
